export const textEn =
  {
    tit:"Contact us",
    name:"Name",
    nameE:"Jhon doe",
    email:"Email",
    emailE:"Jhon@mail.com",
    message:"Message",
    messageE:"...",
    btn:"Submit",
    fail:"The message could not be sent, if the problem persists contact info@otmtrading.com",
    succes:"The message was sent successfully. We will contact you soon.",

  };


export const textEs =
  {
    tit:"Contactanos",
    name:"Nombre",
    nameE:"Jhon doe",
    email:"Email",
    emailE:"Jhon@mail.com",
    message:"Mensaje",
    messageE:"...",
    btn:"Enviar",
    fail:"El mensaje no pudo ser enviado, si el problema persiste comunicarse con info@otmtrading.com",
    succes:"El mensaje fue enviado exitosamente. Pronto nos contactaremos contigo.",

  };
